import { HTMLProps, PropsWithChildren } from "react";

const InputGroup = ({
  header,
  children,
  className,
}: {
  header?: string;
  className?: HTMLProps<HTMLElement>["className"];
} & PropsWithChildren) => {
  return (
    <div>
      {header && (
        <h3 className="font-noto-sans font-bold text-xl mb-2">{header}</h3>
      )}
      <div className={className}>{children}</div>
    </div>
  );
};
export default InputGroup;
